export default __webpack_public_path__ + "static/media/vscode.e25352d1.webp";